class App {
    constructor() {

        this.resizeEvt = null;
        this.$ = jQuery;
        this.$window = this.$(window);
        this.wH = this.$window.height();
        this.wW = this.$window.width();
    }

    init(){
        this.$( window ).on( 'load',  this._onLoaded() );
    }

    _onLoaded(){

    }

    _bindResize(){

        let self = this;

        this.$window.resize(function () {
            clearTimeout(self.resizeEvt);
            self.resizeEvt = setTimeout(function () {
                self._onResize();
            }, 100);
        });

    }

    _onResize(){


    }
}

export default App;



// WEBPACK FOOTER //
// ./scripts/classes/app.js